// ===========================================
// ADMIN TOAST CONTEXT
// ===========================================

import { createContext } from 'react';
import type { ToastMessage } from './ToastProvider';

interface ToastContextValue {
  notify: (toast: Omit<ToastMessage, 'id'>) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
